module.exports = __webpack_public_path__ + "static/lifecycle-47b288cdc73095d12e330bd32d36637f.png";